module.exports = __webpack_public_path__ + "static/media/scan.7f27d996.png";